
<template>

	<div>

		{{ value[1] }}

	</div>

</template>

<script>

export default
{
	props :
	{
		value : Array
	}
}

</script>

